<div class="chat-head">
  <button *ngIf="showBack" type="button" class="chat-head__btn chat-head__btn--back" [attr.aria-label]="strings.backToList" (click)="back.emit()">
    <chat-icon name="back" [size]="20"></chat-icon>
  </button>
  <chat-avatar [src]="photo" [name]="name" [size]="44" [status]="presence"></chat-avatar>
  <div class="chat-head__text">
    <div class="chat-head__title">
      <span class="chat-head__name">{{ name }}</span>
      <span *ngIf="roleText" class="chat-head__pill" [class.chat-head__pill--team]="role && role !== 'USERS'">{{ roleText }}</span>
    </div>
    <div class="chat-head__sub" [class.chat-head__sub--typing]="typing" [class.chat-head__sub--online]="!typing && presence === 'online'">
      <ng-container *ngIf="typing; else stateText">
        <span class="chat-typing" aria-hidden="true"><i></i><i></i><i></i></span>{{ typingMode === 'voice' ? strings.recordingVoice : strings.typing }}
      </ng-container>
      <ng-template #stateText>
        <span *ngIf="presence === 'online' || presence === 'away'" class="chat-head__dot" [class.chat-head__dot--away]="presence === 'away'"
          aria-hidden="true"></span><span class="chat-head__sub-text">{{ subtitle }}</span>
      </ng-template>
    </div>
  </div>

  <div class="chat-head__actions">
    <button *ngIf="canInvite" type="button" class="chat-head__btn" [attr.aria-label]="strings.invite" [ngbTooltip]="strings.invite"
      container="body" (click)="invite.emit()">
      <chat-icon name="userplus" [size]="18"></chat-icon>
    </button>
    <button type="button" class="chat-head__btn" [class.chat-head__btn--on]="searchOpen" [attr.aria-label]="strings.searchInConversation"
      [attr.aria-pressed]="searchOpen" [ngbTooltip]="strings.searchInConversation" container="body" (click)="toggleSearch.emit()">
      <chat-icon name="search" [size]="18"></chat-icon>
    </button>
    <button type="button" class="chat-head__btn chat-head__btn--details" [class.chat-head__btn--on]="detailsOpen" [attr.aria-label]="strings.details"
      [attr.aria-pressed]="detailsOpen" [ngbTooltip]="strings.details" container="body" (click)="toggleDetails.emit()">
      <chat-icon name="info" [size]="18"></chat-icon>
    </button>
    <div *ngIf="propertyLink || propertyRoute" class="chat-head__menu">
      <button type="button" class="chat-head__btn" [attr.aria-label]="strings.more" aria-haspopup="menu"
        [attr.aria-expanded]="menuOpen" [ngbTooltip]="strings.more" container="body" (click)="toggleMenu()">
        <chat-icon name="more" [size]="18"></chat-icon>
      </button>
      <div *ngIf="menuOpen" class="chat-head__popover" role="menu">
        <a *ngIf="propertyLink" role="menuitem" class="chat-head__item" [href]="propertyLink" target="_blank" rel="noopener"
          (click)="menuOpen = false">
          <chat-icon name="home" [size]="15"></chat-icon>
          {{ strings.openPropertySite }}
        </a>
        <a *ngIf="propertyRoute" role="menuitem" class="chat-head__item" [routerLink]="propertyRoute" [queryParams]="propertyQueryParams"
          (click)="menuOpen = false">
          <chat-icon name="next" [size]="15"></chat-icon>
          {{ strings.openProperty }}
        </a>
      </div>
    </div>
  </div>
</div>
